import React, { Component } from 'react';
import '../css/App.css';

import 'whatwg-fetch';

// import { browserHistory } from 'react-router';
import  { Redirect, withRouter } from 'react-router-dom';
// import { Chart } from 'react-google-charts';
// import { withStyles } from '@material-ui/core/styles';
// import theme from '../components/Theme';
import {request, formatCurrency, gFormatCurrency, gFormatNumber, formatNumber, dateFromObjectId, languageCheckAndReload} from '../util';

import Header from '../components/Header';
import ConsumptionList from "../components/statistics/ConsumptionList";
import DatePicker from "../components/DatePicker";
import config from "../config";

import { translate } from "../i18n/customI18nProvider";
import Account from "../components/statistics/Account";
import ConsumptionsLineChart from "../components/statistics/ConsumptionsLineChart";
import VouchersTable from '../components/statistics/VouchersTable';
import PeopleInEventLineChart from "../components/statistics/PeopleInEventLineChart";
import SmartphonesInEventTable from "../components/statistics/SmartphonesInEventTable";
import ConsumptionsColumnChart from "../components/statistics/ConsumptionsColumnChart";
import ChargementsLineChart from "../components/statistics/ChargementsLineChart";
import EntranceCount from "../components/statistics/EntranceCount";
import DetailedConsumptions from "../components/statistics/DetailedConsumptions";
import { colors, Grid } from '@material-ui/core';
import DetailedTransactionsExceptConsumptions from '../components/statistics/DetailedTransactionsExceptConsumptions';
import { getName, getRight, getToken, setName } from '../services/storage';
import MyPOSInEventTable from '../components/statistics/MyPOSInEventTable';
import MyPOSUltraInEventTable from '../components/statistics/MyPOSUltraInEventTable';

function compareSecondColumn(a, b) {
    if (a[1].v === b[1].v) {
        return 0;
    }
    else {
        return (a[1].v > b[1].v) ? -1 : 1;
    }
}

export default class Statistics extends Component {

    constructor(){
        super();
        this.state = {
            token: getToken(),
            right: getRight(),
            loading: true,
            statistics: {
                global: {},
                consumptions: [],
                entrances: [],
                history_debit: [],
                history_credit: [],
                history_people: [],
                history_people_in_event: []
            },
            mobileOpen: false,
            bar: {_id: ''},
            bars: [],
            test: [],
            domain_error: false,
            general_information: {
                name: getName() ? getName() : "Web App",
                dateBegin: null,
                dateEnd: null
            },
            dateBegin: '',
            dateEnd: ''
        };

        this.canReload = false;

    }

    async updateStatistics(pathname){

        if(!this.state.token)
            return;

        const pname = pathname ? pathname.split("/") : null;
        const urlParams = new URLSearchParams(window.location.search);

        let new_state = this.state;

        new_state["loading"] = true;
        this.setState({'loading' : true});

        let dateBegin = null;
        let dateEnd = null;
        let bar_id = null;
        
        if(pname.length === 3) {
            bar_id = pname[2];
            dateBegin = null;
            dateEnd = null;
        } else if(pname.length === 4) {
            bar_id = '';
            dateBegin = pname[2];
            dateEnd = pname[3];
        } else if(pname.length === 5) {
            bar_id = pname[2];
            dateBegin = pname[3];
            dateEnd = pname[4];
        }

        if(this.state.bars.length === 0){
            let bars = await request('/bars', 'GET', null)
            if(bars && !bars.error && bars.status !== 502) {
                const formattedBars = bars.map(
                    bar => ({name: bar.name, link: '/statistics/' + bar._id, _id: bar._id})
                );
                this.setState({'bars' : formattedBars});
            }
        }

        await this.statistics(bar_id, urlParams.get('dateBegin'), urlParams.get('dateEnd'));
    }

    async componentDidMount(){

        let general_information = await request('/events/general', 'GET', null);
        if(general_information.error) {
            alert(general_information.error);
            return;
        }
        languageCheckAndReload(general_information.language);
        setName(general_information?.name || '');
        this.setState({general_information: general_information});
        
        this.unlisten = this.props.history.listen((location, action) => {
            // window.location.href = window.location.href;
            // this.setState({loading: true});
            this.updateStatistics(location.pathname);
            // this.setState({})
        });

        this.updateStatistics(window.location.pathname);
    }

    componentWillUnmount() {
        try {
            this.unlisten();
        } catch(e) {}
    }

    format_history = (history_stats, currency = true) => {
        const gFormat = currency ? gFormatCurrency : gFormatNumber;
        if(!history_stats)
            return;
        for(let i = 1; i < history_stats.length; i++){
            history_stats[i][0] = new Date(history_stats[i][0]);
            for(let j = 1; j < history_stats[i].length; j ++)
                history_stats[i][j] = gFormat(history_stats[i][j]);
        }
    };

    statistics = async(bar_id, dateBegin=null, dateEnd=null) => {

        bar_id = bar_id ? '/' + bar_id : '';
        
        let urlParams = '';
        if (dateBegin && dateEnd)
            urlParams += `?dateBegin=${dateBegin}&dateEnd=${dateEnd}`;

        const statistics = await request('/v1/statistics' + bar_id + urlParams, 'GET', null)

        let barObj = this.state.bars.find(b => b._id === bar_id);
        
        if(!barObj && bar_id) {
            const singleBar = await request('/bars/' + bar_id, 'GET', null);
            barObj = (singleBar && !singleBar.error) ? singleBar : { _id: bar_id, name: "Error" };
        } else if (!bar_id) {
            barObj = { _id: '', name: this.state.bars.length == 1 ? this.state.bars[0].name : '' };
        }
        
        this.setState({
            statistics,
            bar: barObj,
            dateBegin: statistics.dateBegin || dateBegin,
            dateEnd: statistics.dateEnd || dateEnd,
            loading: false
        });
        this.canReload = true;
    };

    render() {

        if(!this.state.token)
            return (<Redirect to='/login'  />);
        else
            return this.statistics_render();
    }

    handleRefreshClick = () => {
        if(this.canReload)
            this.updateStatistics(window.location.pathname);
    }

    statistics_render(){
        document.title = getName() ? getName() : config.applicationName;
        let statistics = (
            <div>
                <div className="print">
                    <h1 style={{textAlign: 'center', color: config.baseColor}}>{this.state?.general_information?.name}</h1>
                    <h2 style={{textAlign: 'center', color: config.baseColor}}>{this.state?.bar?.name}</h2>
                </div>
                <DatePicker
                    baseUrl='/statistics'
                    barId={this.state.bar._id}
                    dateBegin={this.state.dateBegin}
                    dateEnd={this.state.dateEnd}
                    minDateBegin={this.state.general_information.dateBegin}
                    maxDateEnd={this.state.general_information.dateEnd}
                    dayStartTime={this.state.general_information.dayStartTime}
                />

                {/* Movements Table */}
                <Account statistics={this.state.statistics.bilan} dateBegin={this.state.dateBegin} dateEnd={this.state.dateEnd} />

                {/* Entrance Count Table */}
                <EntranceCount clients={this.state.statistics.clients} entrances={this.state.statistics.entrances} />
                
                {/*Chargements Line Chart*/}
                <ChargementsLineChart
                    history={this.state.statistics.history}
                    currencyCode={this.state.general_information?.currencyCode}
                    currencySymbol={this.state.general_information?.currencySymbol}
                />
                
                {/*Consumptions Line Chart*/}
                <ConsumptionsLineChart
                    history={this.state.statistics.history}
                    currencyCode={this.state.general_information?.currencyCode}
                    currencySymbol={this.state.general_information?.currencySymbol}
                />
                
                {/*People In Event Line Chart*/}
                <PeopleInEventLineChart historyPeople={this.state.statistics.historyPeople} />

                {/* All Transactions View */}
                <Grid container spacing={3} className="noPrint">
                    <Grid item xs={12} sm={6}>
                        <DetailedTransactionsExceptConsumptions
                            barId={this.state.bar._id}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <DetailedConsumptions
                            barId={this.state.bar._id}
                        />
                    </Grid>
                </Grid>

                {/* Smartphones In Event Table */}
                <SmartphonesInEventTable smartphonesInEvent={this.state.statistics.smartphonesInEvent} />

                {/* MyPOS Ultra In Event Table */}
                <MyPOSUltraInEventTable myposUltraInEvent={this.state.statistics.myposUltraInEvent} />
                
                {/* MyPOS In Event Table */}
                <MyPOSInEventTable myposInEvent={this.state.statistics.myposInEvent} />

                {/*Consumptions Column Chart*/}
                <ConsumptionsColumnChart
                    barsDebit={this.state.statistics.barsDebit}
                    currencyCode={this.state.general_information?.currencyCode}
                    currencySymbol={this.state.general_information?.currencySymbol}
                />
            
                {/* Vouchers Table */}
                <VouchersTable vouchers={this.state.statistics.vouchers} />
                
                {/*Consumption List*/}
                <ConsumptionList
                    consumptions={this.state.statistics.consumptions}
                    general_information={this.state.general_information}
                    currencyCode={this.state.general_information?.currencyCode}
                    currencySymbol={this.state.general_information?.currencySymbol}
                />
            </div>
        );

        return (
                <Header
                    title={this.state?.bar?.name ? translate('custom.statistics') + ' \'' + this.state.bar.name + '\'' : translate('custom.statistics')}
                    name={this.state?.general_information?.name}
                    items={this.state.bars}
                    loading={this.state.loading}
                    home='/statistics'
                    refreshClicked = {this.handleRefreshClick}
                >
                    {(!this.state.loading && this.state.statistics && !this.state.domain_error) ? statistics : null}
                    {(!this.state.loading && this.state.domain_error) ? <h2 style={{textAlign: 'center', height: '100%'}}>{translate('custom.wrong_domain')}</h2> : null}
                </Header>
        );
    }
}

// const styles = theme => ({
// });

const styles = theme => ({
});


// export default withRouter(withStyles(styles)(Statistics));
// export default withStyles(styles)(Statistics);
// export default withRouter(Statistics);
